import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useAtom } from "jotai";
import { FC, useEffect, useState } from "react";
import { modalTemplate, templateEditAtom } from "../../../atoms/atom";
import { DocumentsService } from "../../../services/DocumentService";
import { TemplateDTO } from "../../../types/TemplateDTO";
import { useAlert } from "../../contextProviders/AlertProvider";
import './CreateTemplateModal.scss';

const CreateTemplateModal: FC = () => {
	const [template, setTemplate] = useState({} as TemplateDTO);
	const [open, setOpen] = useAtom(modalTemplate);
	const [templateEdit, setTemplateEdit] = useAtom(templateEditAtom);
	const { showAlert, showError } = useAlert();

	const handleChange = (field: keyof TemplateDTO, value: string) => {
		setTemplate(prev => ({
		...prev,
		[field]: value
		}));
	};

	useEffect(() => {
		if (templateEdit) {
			setTemplate(templateEdit);
		}
	}, [templateEdit]);

	return (
		<Dialog
			open={open}
			onClose={() => {
				setOpen(false);
				setTemplateEdit(null);
			}}
			id='modal-template'
		>
			<DialogTitle>{templateEdit ? "Editar" : "Adicionar"} template</DialogTitle>
			<DialogContent id="modal-template-content">
				<TextField
					label="Título do template"
					id="template-title"
					size="medium"
					helperText="Usado como assunto, se enviado por e-mail"
					value={template.title}
					disabled={!!templateEdit}
					onChange={(e) => handleChange('title', e.target.value)}
				/>
				<TextField
					label="Mensagem do template"
					id="template-message"
					size="medium"
					value={template.message}
					multiline
					onChange={(e) => handleChange('message', e.target.value)}
				/>
			</DialogContent>
			<DialogActions>
				<Button id="close-title-button" onClick={() => setOpen(false)}>
					Fechar
				</Button>
				<Button
					disabled={!template.title || !template.message}
					id="create-template-button"
					color="success"
					onClick={() => save()}
				>
					Salvar
				</Button>
			</DialogActions>
		</Dialog>
	);

	async function save() {
		try {
			const response = await new DocumentsService().createTemplate(template);
			if (response && response.status === 200) {
				showAlert("Template criado com sucesso!");
				setTemplate({} as TemplateDTO);
				setOpen(false);
			}
		} catch (error) {
			showError();
		}
	}
}

export default CreateTemplateModal;